/**
 * @preserve
 * Licenses of bundled dependencies can be found in dependencies-licenses.txt
 */
var applyAttribute=function(t,a,e){if(e){t.setAttribute(a,"")}else{t.removeAttribute(a)}};export{applyAttribute as a};
//# sourceMappingURL=apply-attribute-df4c8f33.js.map